import { render, staticRenderFns } from "./chatbox.vue?vue&type=template&id=0828d887"
import script from "./chatbox.vue?vue&type=script&lang=js"
export * from "./chatbox.vue?vue&type=script&lang=js"
import style0 from "./chatbox.vue?vue&type=style&index=0&id=0828d887&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports